import React from "react";
import { Box, Typography, FormControl, FormLabel } from "@mui/joy";

export const ESTIMATING_CONFIG = {
    STEEP_RATES: {
        "7-9": "25.00",
        "10-12": "45.00",
        "13+": "75.00",
    },
    OPTIONS: {
        PAYMENT_TYPES: [
            { value: "insurance", label: "Insurance Claim" },
            { value: "cash", label: "Cash / Check" },
            { value: "credit", label: "Credit Card" },
            { value: "debit", label: "Debit Card" },
            { value: "financing", label: "Financing" },
        ],
        STEEP_LEVELS: [
            { value: "7-9", label: "7/12 - 9/12 (Standard)" },
            { value: "10-12", label: "10/12 - 12/12 (High)" },
            { value: "13+", label: "> 12/12 (Extreme)" },
        ],
        LAYERS: [
            { value: "1", label: "1 Layer" },
            { value: "2", label: "2 Layers" },
            { value: "3", label: "3+ Layers" },
        ],
        STORIES: [
            { value: "1", label: "1 Story" },
            { value: "2", label: "2 Story" },
            { value: "3", label: "3+ Story" },
        ],
    },
};

interface SettingFieldProps {
    label: string;
    description?: string;
    children: React.ReactNode;
    horizontal?: boolean;
}

export const SettingField = ({ label, description, children, horizontal = true }: SettingFieldProps) => {
    if (!horizontal) {
        return (
            <FormControl size="sm">
                <FormLabel sx={{ mb: 0.5 }}>{label}</FormLabel>
                {description && <Typography level="body-xs" sx={{ mb: 1 }}>{description}</Typography>}
                {children}
            </FormControl>
        );
    }

    return (
        <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ gap: 2 }}>
            <Box>
                <Typography level="body-sm" fontWeight="500">{label}</Typography>
                {description && <Typography level="body-xs">{description}</Typography>}
            </Box>
            <Box sx={{ minWidth: 100 }}>
                {children}
            </Box>
        </Box>
    );
};
